<template>
    <div class="wrapper">
        <div class="inner">
            <div class="media-container">
                <img v-if="mediaType == 'pic'" class="selected-pic" :src="mediaPath" />
                <div class="audio-wrapper" v-if="mediaType === 'aud'">
                    <div v-if="!recorded">
                        <img
                            v-if="!recording"
                            src="@/assets/icon-images/mic.png"
                            @click="isCordova ? startCordovaAudioRecording() : startAudioRecording()"
                            size="large"
                            class="ion-float-start icon-img-lg record-icon"
                        />
                        <img
                            v-else
                            src="@/assets/icon-images/stop.png"
                            @click="isCordova ? stopCordovaAudio() : stopAudioRecording()"
                            size="large"
                            class="ion-float-start icon-img-lg record-icon"
                        />
                    </div>
                    <div v-else>
                        <audio class="audio-player" controls>
                            <source :src="audioUrl" type="audio/mpeg" />
                            {{ $t('chat.audioNotSupported') }}
                        </audio>
                    </div>
                </div>
                <div class="video-wrapper">
                    <video v-if="mediaType == 'vid'" controls>
                        <source :src="mediaPath" type="video/mp4" />
                        {{ $t('chat.videoNotSupported') }}
                    </video>
                </div>
            </div>
            <div class="title-container">
                <input v-model="title" :placeholder="$t('chat.titlePlaceholder')" />
            </div>
            <div class="buttons-wrapper">
                <ion-button class="send-button ion-float-start" @click="handleSend">{{ $t('chat.send') }}</ion-button>
                <ion-button class="cancel-button ion-float-end" @click="handleCancel">{{ $t('master.cancel') }}</ion-button>
            </div>
        </div>
    </div>
</template>

<script>
import AudioController from '@/controllers/AudioController'

export default {
    name: 'SendMediaPopup',
    props: ['path', 'type'],
    data() {
        return {
            isCordova: typeof window.cordova !== 'undefined',
            title: '',
            mediaPath: null,
            mediaType: null,
            audioChunks: [],
            audioBlob: null,
            audioUrl: null,
            recording: false,
            recorded: false,
            mediaRecorder: null
        }
    },
    watch: {
        path(path) {
            this.mediaPath = path
        },
        type(type) {
            this.mediaType = type
        }
    },
    methods: {
        handleSend: function() {
            if (!this.title) {
                this.showAlert(this.$t('chat.addTitle'))
                return
            }
            if (this.mediaType == 'pic' || this.mediaType == 'vid') {
                this.$emit('send', { type: this.mediaType, title: this.title })
            } else if (this.mediaType == 'aud') {
                if (this.audioBlob) {
                    this.$emit('send', { type: this.mediaType, title: this.title, file: this.audioBlob })
                    this.recorded = false
                    this.recording = false
                    this.audioBlob = null
                } else {
                    this.showAlert(this.$t('chat.addAudio'))
                    return
                }
            }
            this.title = ''
        },
        handleCancel: function() {
            this.title = ''
            this.$emit('cancel')
            this.recorded = false
            this.recording = false
            this.audioBlob = null
        },
        showAlert: function(string) {
            return this.$ionic.alertController
                .create({
                    message: string,
                    buttons: ['OK']
                })
                .then(a => a.present())
        },
        stopAudioRecording() {
            this.mediaRecorder.stop()
        },
        startAudioRecording() {
            navigator.permissions.query({ name: 'microphone' }).then(permissionObj => {
                if (permissionObj.state === 'denied') {
                    alert('Allow microphone access to send audio messages')
                }
                navigator.mediaDevices.getUserMedia({ audio: true }).then(stream => {
                    this.mediaRecorder = new MediaRecorder(stream)
                    this.mediaRecorder.start()
                    this.recording = true
                    this.audioChunks = []
                    this.mediaRecorder.addEventListener('dataavailable', event => {
                        this.audioChunks.push(event.data)
                    })

                    this.mediaRecorder.addEventListener('stop', () => {
                        this.audioBlob = new Blob(this.audioChunks)
                        this.audioChunks = []
                        this.recorded = true
                        this.audioUrl = URL.createObjectURL(this.audioBlob)
                        this.mediaRecorder = null
                        stream
                            .getTracks() // get all tracks from the MediaStream
                            .forEach(track => track.stop()) // stop each of them
                    })
                })
            })
        },
        startCordovaAudioRecording() {
            const self = this
            // First check whether we already have permission to access the microphone.
            window.audioinput.checkMicrophonePermission(function(hasPermission) {
                if (hasPermission) {
                    self.captureCordovaAudio()
                } else {
                    // Ask the user for permission to access the microphone
                    window.audioinput.getMicrophonePermission(function(hasPermission, message) {
                        if (hasPermission) {
                            self.captureCordovaAudio()
                        } else {
                            console.warn('User denied permission to record.')
                        }
                    })
                }
            })
        },
        captureCordovaAudio() {
            if (window.audioinput && !window.audioinput.isCapturing()) {
                this.recording = true
                this.audioChunks = []

                window.addEventListener('audioinput', this.onAudioInput, false)
                window.addEventListener('audioinputerror', this.onAudioInputError, false)
                window.addEventListener('audioinputfinished', this.onAudioInputFinished, false)
                window.audioinput.start({ channels: audioinput.CHANNELS.MONO })
            }
        },
        onAudioInput(evt) {
            console.log('RECONRDING4', evt.data)
            this.audioChunks = [...this.audioChunks, ...evt.data]
        },
        onAudioInputError(error) {
            console.log('ERROR', error)
        },
        onAudioInputFinished() {
            window.removeEventListener('audioinput', this.onAudioInput)
            window.removeEventListener('audioinputerror', this.onAudioInputError)
            window.removeEventListener('audioinputfinished', this.onAudioInputFinished)

            const audioController = new AudioController(window.audioinput.getCfg().sampleRate, window.audioinput.getCfg().channels)

            audioController.encode([this.audioChunks])
            this.audioBlob = audioController.finish('audio/wav')

            var reader = new FileReader()
            reader.onload = evt => {
                this.audioUrl = evt.target.result
                this.audioChunks = []
                this.recorded = true
                this.mediaRecorder = null
            }

            reader.readAsDataURL(this.audioBlob)
        },
        stopCordovaAudio() {
            window.audioinput.stop(() => {
                window.removeEventListener('audioinput', this.onAudioInput)
                window.removeEventListener('audioinputerror', this.onAudioInputError)
                const audioController = new AudioController(window.audioinput.getCfg().sampleRate, window.audioinput.getCfg().channels)

                audioController.encode([this.audioChunks])
                this.audioBlob = audioController.finish('audio/wav')

                var reader = new FileReader()
                reader.onload = evt => {
                    this.audioUrl = evt.target.result
                    this.audioChunks = []
                    this.recorded = true
                    this.mediaRecorder = null
                }

                reader.readAsDataURL(this.audioBlob)
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.wrapper {
    width: 100%;
    height: 100%;
    top: 5.5%;
    left: 0;
    background-color: rgba(0, 0, 0, 0.5);
    position: fixed;
    z-index: 11;

    .inner {
        background-color: #7cc18b;
        width: 80%;
        z-index: 9;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        padding: 4%;
        border-radius: 10px;

        .media-container {
            img {
                max-height: 30vh;
            }

            .audio-wrapper {
                height: 10vh;
            }
            .record-icon {
                margin: 0 auto;
                display: inline-block;
                top: 10%;
                left: 50%;
                position: absolute;
                transform: translate(-50%, 10px);
                border: 2px solid black;
                padding: 1px;
                border-radius: 50%;
            }

            .video-wrapper {
                video {
                    max-height: 30vh;
                    max-width: 100%;
                }
            }
        }

        .title-container input {
            opacity: 0.7;
            width: 100%;
            padding: 10px 10px;
            margin: 5% 0;
            border-radius: 10px;
            border: none;
        }
        .audio-player {
            max-width: 80%;
            margin: 10%;
            display: block;
        }
    }
}

@media (min-width: 1200px) {
    .wrapper {
        .inner {
            width: 30%;
        }
    }
}
</style>
